import React from "react";
import { cn } from "../../lib/utils";

type LinkVariant = "default" | "muted" | "nav" | "footer" | "premium";

const linkVariantClassName: Record<LinkVariant, string> = {
  default:
    "text-primary transition-colors hover:text-premium-700 hover:underline",
  premium:
    "text-premium-600 transition-colors hover:text-premium-500 hover:underline",
  muted: "text-muted-foreground transition-colors hover:text-foreground",
  nav: "text-sm font-medium text-muted-foreground transition-colors hover:text-foreground",
  footer:
    "text-sm text-muted-foreground transition-colors hover:text-foreground",
};

type LinkStyleProps = {
  variant?: LinkVariant;
};

type AnchorProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> &
  LinkStyleProps & {
    href?: string;
    to?: string;
  };

export const LinkAnchor = React.forwardRef<HTMLAnchorElement, AnchorProps>(
  ({ className, href, to, variant = "default", ...props }, ref) => {
    const classes = cn(linkVariantClassName[variant], className);
    return <a ref={ref} className={classes} href={href ?? to} {...props} />;
  },
);
LinkAnchor.displayName = "LinkAnchor";

type AppLinkProps = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  "href"
> & {
  href?: string;
  to: string;
  variant?: LinkVariant;
};

export const AppLink = React.forwardRef<HTMLAnchorElement, AppLinkProps>(
  ({ className, href, to, variant = "default", ...props }, ref) => (
    <a
      ref={ref}
      href={href ?? to}
      className={cn(linkVariantClassName[variant], className)}
      {...props}
    />
  ),
);
AppLink.displayName = "AppLink";
